import { FC } from 'react';
import { Input } from 'components';
import { MagnifierSearch } from 'components/icons';

interface IntegerFilterProps {
    setFilter: (updater: any) => void;
    filter: any;
}

const IntegerFilter: FC<IntegerFilterProps> = ({ filter, setFilter }) => {
    return (
        <Input
            isFullWidth={true}
            icon={<MagnifierSearch size={16} />}
            margin={'none'}
            type="number"
            value={filter?.value || ''}
            onChange={(event) => setFilter({ value: event.target.value })}
            onKeyDown={(event) => {
                if (!event.key.match(/\d/) && event.key !== 'Backspace') {
                    event.preventDefault();
                }
            }}
            isFocused={true}
        />
    );
};

export default IntegerFilter;
